import type { WhatsAppStatus } from "@/types/result";

const styles: Record<WhatsAppStatus, string> = {
  not_sent: "bg-gray-100 text-gray-700",
  queued: "bg-blue-100 text-blue-700",
  sent: "bg-emerald-100 text-emerald-700",
  delivered: "bg-emerald-100 text-emerald-700",
  read: "bg-emerald-100 text-emerald-700",
  failed: "bg-red-100 text-red-700",
  skipped: "bg-yellow-100 text-yellow-800",
};

export function WhatsAppStatusBadge({ status }: { status: WhatsAppStatus }) {
  return <span className={`inline-flex rounded px-2 py-1 text-xs font-medium ${styles[status]}`}>{status}</span>;
}
